var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CommandSocketInitializer } from './framework/CommandSocketInitializer';
import { Timeouts } from './framework/Timeouts';
export class SonyBravia {
    constructor(socket, state, log, framework) {
        this.socket = socket;
        this.state = state;
        // other class properties and constructor
        this.timeouts = new Timeouts();
        this.busyTimeout = this.timeouts.create();
        // controls
        this.busy = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                return this.state.busy.value;
            }),
        };
        this.displayBlank = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('*SEPMUT################', /\*SAPMUT000000000000000(\d)/i, tags);
                return match[1] === '1';
            }),
            set: (blank, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`*SCPMUT000000000000000${blank ? '1' : '0'}`, /\*SNPMUT000000000000000(\d)/i, tags, { sendTimeoutMs: 8000 });
                return match[1] === '1';
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.power = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('*SEPOWR################', /\*SAPOWR0+(\d)|\*SAPOWRF+/i, tags);
                if (match[1])
                    return match[1] === '1';
                return this.state.power.value;
            }),
            set: (power, tags) => __awaiter(this, void 0, void 0, function* () {
                this.busyTimeout.clear();
                const match = yield this.socket.send(`*SCPOWR000000000000000${power ? '1' : '0'}`, /\*SAPOWR0+(\d)|\*SAPOWRF+/i, tags);
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), power ? 4000 : 1000);
                if (match[1])
                    return match[1] === '1';
                return this.state.power.value;
            }),
            asyncHandlers: {
                regExp: /\*SNPOWR000000000000000(\d)/i,
                callback: (match) => {
                    this.state.power.update(match[1] === '1');
                },
            },
        };
        this.videoInput = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('*SEINPT################', /\*SAINPT0000000(\d+)/i, tags, { sendTimeoutMs: 3000 });
                return match[1];
            }),
            set: (code, tags) => __awaiter(this, void 0, void 0, function* () {
                this.busyTimeout.clear();
                const match = yield this.socket.send(`*SCINPT0000000${code}`, /\*SNINPT0000000(\d+)/i, tags, { sendTimeoutMs: 3000 });
                this.state.busy.update(true);
                this.busyTimeout.set(() => this.state.busy.update(false), 1000);
                return match[1];
            }),
            powerOffRestrictions: ['get', 'set'],
        };
        this.volume = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('*SEVOLU################', /\*SAVOLU0000000000000(\d+)/i, tags);
                return parseInt(match[1], 10);
            }),
            set: (volume, tags) => __awaiter(this, void 0, void 0, function* () {
                const vol = volume.toString().padStart(3, '0');
                const match = yield this.socket.send(`*SCVOLU0000000000000${vol}`, /\*SAVOLU0000000000000(\d+)|\*SAVOLUF\d+/i, tags);
                if (match[1])
                    return parseInt(match[1], 10);
                return this.state.volume.value;
            }),
            asyncHandlers: {
                regExp: /\*SNVOLU0000000000000(\d+)/i,
                callback: (match) => {
                    this.state.volume.update(parseInt(match[1], 10));
                },
            },
            powerOffRestrictions: ['get', 'set'],
            range: { max: 100, min: 0, round: 1 },
        };
        this.volumeMute = {
            get: (tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send('*SEAMUT################', /\*SAAMUT000000000000000(\d)/i, tags);
                return match[1] === '1';
            }),
            set: (mute, tags) => __awaiter(this, void 0, void 0, function* () {
                const match = yield this.socket.send(`*SCAMUT000000000000000${mute ? '1' : '0'}`, /\*SAAMUT000000000000000(\d)|SAAMUTF\d+/i, tags);
                return match[1] ? match[1] === '1' : this.state.volumeMute.value;
            }),
            asyncHandlers: {
                regExp: /\*SNAMUT000000000000000(\d)/i,
                callback: (match) => {
                    this.state.volumeMute.update(match[1] === '1');
                },
            },
            powerOffRestrictions: ['get', 'set'],
        };
        // polling
        this.polls = [
            {
                intervalMs: 4000,
                controls: ['power', 'videoInput', 'volume', 'volumeMute', 'displayBlank'],
            },
        ];
    }
    // phase callbacks
    onConfigure(config) {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onDisconnect() {
        return __awaiter(this, void 0, void 0, function* () {
            this.timeouts.clearAll();
        });
    }
    onInitialize(credentials) {
        return __awaiter(this, void 0, void 0, function* () {
            const initializerSteps = [
                {
                    errorCode: 'verifyFailed',
                    send: '*SEPOWR################',
                    next: /SAPOWR\d+/i,
                },
            ];
            return yield CommandSocketInitializer.initialize(this.socket, initializerSteps, credentials);
        });
    }
}
// static properties
SonyBravia.driverType = 'socketDriver';
SonyBravia.key = '-LrVWtqZOnvSZhCMT0sZ';
SonyBravia.socketOptions = [
    {
        commandExtractor: {
            terminators: ['\n'],
        },
        sendTerminator: '\n',
        port: 20060,
    },
];
